/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mzukisi's Portfolio",
  description:
    "A passionate Python, JavaScript and C/C++ software developer and linux enthusiast.",
  og: {
    title: "Mzukisi Makaluza Portfolio",
    type: "website",
    url: "http://mzukisimakaluza.com/",
  },
};

//Home Page
const greeting = {
  title: "Mzukisi Makaluza",
  logo_name: "MzukisiMakaluza",
  nickname: "Smurphy",
  subTitle:
    "A Full Stack Software Developer specializing in NodeJS, VueJS, Python and C/C++",
  resumeLink:
    "https://drive.google.com/file/d/1lshfOmfNG_blKB9P-SfX8FHhQ0YAysv8/view?usp=drive_link",
  portfolio_repository: "https://github.com/mzukisimakaluza-dev/masterPortfolio",
  githubProfile: "https://github.com/mzukisimakaluza-dev",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/mzukisimakaluza-dev",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "Github-2",
    link: "https://github.com/Smurphy7440",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#5c2a22", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mzukisi-makaluza-310951162/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:mzukisimakaluza@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Software Development, Automation & Testing/Debugging",
      // fileName: "DataScienceImg",
      skills: [
        "⚡ Development of Backend microservices with NodeJS and MySQL",
        "⚡ Development of Linux-based microservices with C/C++",
        "⚡ Network Analysis with Wireshark",
        "⚡ Automating server functionalities and setups with Bash",
        "⚡ Reading Linux Server logs and traces",
        "⚡ API Test Automation with Python Scripts",
      ],
      softwareSkills: [
        {
          skillName: "Wireshark",
          fontAwesomeClassname: "simple-icons:wireshark",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Bash",
          fontAwesomeClassname: "simple-icons:linux",
          style: {
            backgroundColor: "transparent",
            color: "#000000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive websites (front-end) using VueJS",
        "⚡ Creating application backend in Node (with Express & Mongo, MySQL or Elasticsearch)",
        "⚡ Creating application backend logic in Python",
        "⚡ Building Linux-based microservices with C/C++"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "VueJS",
          fontAwesomeClassname: "simple-icons:vuedotjs",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Virtual Servers/Environments",
      // fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working with Docker networks and Containers",
        "⚡ Python Virtual Environments",
        "⚡ Familiar with Linux's virtual network interfaces",
        "⚡ Virtual development inside docker containers ( Keeping the host clean )",
      ],
      softwareSkills: [
        {
          skillName: "Python pip3",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Neural Networks and Deep Learning",
      iconifyClassname: "simple-icons:matrix",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.coursera.org/account/accomplishments/verify/3VR8FKJKNXH7",
    },
    {
      siteName: "Front-end Web Development with React",
      iconifyClassname: "simple-icons:react",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.coursera.org/account/accomplishments/verify/QHKEHNWYWX92",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/mzukisimakaluza",
    },
    {
      siteName: "CodeWars",
      iconifyClassname: "simple-icons:codewars",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.codewars.com/users/Smurphy7440",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Cape Town",
      subtitle: "BSc Electrical and Computer Engineering",
      logo_path: "uct_logo.png",
      alt_name: "UCT",
      duration: "2017 - 2020",
      descriptions: [
        "⚡ Learned about about core Computer Science principles such as Algorithms and Data Structures, Memory management and IoT based development.",
        "⚡  Learned Calculus I, II and III in the context of Electrical engineering",
        "⚡ Received a Dean's List award in 2017 for exceptional perfomance as can be seen from my transcript.",
      ],
      website_link: "https://uct.ac.za/",
    }
  ],
};

const certifications = {
  certifications: [
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/3VR8FKJKNXH7",
      alt_name: "DeepLearning.AI",
      color_code: "#8C151599",
    },
    {
      title: "Advanced Java Programming",
      subtitle: "- LinkedIn Learning",
      logo_path: "linkedin_learning.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/c592a42ac46e51ca443ab9cae904c959fb1ed011d2ead500ebedb749f914912a",
      alt_name: "LinkedInAdvJava",
      color_code: "#8C151599",
    },
    {
      title: "Front End Development Libraries",
      subtitle: "- FreeCodeCamp",
      logo_path: "free_codecamp.png",
      certificate_link:
        "https://www.freecodecamp.org/certification/fcce772f054-2c1b-44ad-86b4-93e7ddc0279e/front-end-development-libraries",
      alt_name: "FCCFrontend",
      color_code: "#8C151599",
    },
    {
      title: "Frontend Web Development with React",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/QHKEHNWYWX92",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with various well-established companies and startups in Cape Town all geared towards the software development of customer facing products.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Developer and Technical Tester",
          company: "Uman Technologies (TSN Systems GmbH)",
          company_url: "https://tsn.systems/",
          logo_path: "TSN-Logo-RGB.png",
          duration: "April 2022 - October 2023",
          location: "Century City, Cape Town, South Africa",
          description:
            "Designed and created a C/C++ XCP implementation with an API utilized by 20+ client-facing scripts | Wrote Python scripts interfacing with the Linux IPC API, streamlining communication processes | Collaborated with fellow developers on GitLab for code reviews, enhancing overall code quality | Contributed actively to sprint planning sessions, aiding in the successful completion of project milestones and delivery timelines | Performed comprehensive manual testing on TSN devices, identifying and reporting 50+ issues in 3 months |  Educated new clients on hardware and software setup of our product, helping reel in new business | Assisted new developers with hardware setup, reducing onboarding time by over 2 hours per day | Streamlined automated release tests, cutting test cycle duration by over 17% and improving product stability",
          color: "#0879bf",
        },
        {
          title: "Student Engineer",
          company: "Aurecon Group Pty. Ltd",
          company_url: "https://www.aurecongroup.com/",
          logo_path: "aurecon_feature_image-2.jpg",
          duration: "Nov 2019 - Jan 2020",
          location: "Century City, Cape Town, South Africa",
          description:
            "Successfully underwent training in Embedded Systems and PLC configuration/programming, acquiring 5 new skills in the process | Conducted circuit design and simulation tasks utilizing LTSpice, achieving proficiency in 2 simulations for enhanced understanding | Developed and showcased proof-of-concept designs, featuring a water-level sensor using embedded Linux hardware, demonstrating 2 successful prototypes",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Developer Intern",
          company: "Sintrex",
          company_url: "https://sintrex.com/",
          logo_path: "sintrex.jpeg",
          duration: "Mar 2021 - September 2022",
          location: "Cape Town, South Africa",
          description:
            "Completed training on Linux System Administration, earning 78% on an internal examination | Addressed and resolved over  10 number of bugs reported by QA, ensuring a smoother product experience | Participated in code reviews using BitBucket, contributing insights to enhance code quality, and authored over 15 task reports for comprehensive project documentation | Collaborated on Vue.js and Node.js-based client-facing web features as per product owner's requirements, addressing and implementing 7 reported features",
          color: "#000000",
        }
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Developer Student Club Member",
          company: "University of Cape Town",
          company_url:
            "https://www.linkedin.com/company/gdscuct/?originalSubdomain=za",
          logo_path: "dsc_logo.png",
          duration: "Apr 2019 - Nov 2020",
          location: "Rondenbosch, Cape Town, South Africa",
          description:
            "We had a well established developer club at the University of Cape Town which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities in Web and Mobile-based development in ReactJS and Node.",
          color: "#0C9D58",
        },
        {
          title: "Zaio Developer Student",
          company: "Zaio",
          company_url:
            "https://www.zaio.io/",
          logo_path: "zaio.png",
          duration: "Jan 2019 - Nov 2020",
          location: "Rondenbosch, Cape Town, South Africa",
          description:
            "The very first exposure I had in Software Development was with a foundation at the University of Cape Town known as Zaio which was still new at the time. My interest in this field has grown remarkebly ever since.",
          color: "#0C9D58",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects include writing scalable web based applications using JavaScript (VueJS and node), Python. Other projects involve writing C/C++ code for embedded Linux systems like the BeagleBone Black and Raspberry Pi",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ProfileShot.jpg",
    description:
      "I am available on Discord, Github and LinkedIn. You can message me, I will reply within 24 hours. I can help you with Testing, Automation, VueJS, TCP/IP Network Analysis and Opensource Development.",
  },
  blogSection: {
  },
  addressSection: {
    title: "Address",
    subtitle:
      "8 Atlantis Close, Parow North, Cape Town, South Africa, 7500",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/9QLWKWfiR7btdxoSA",
  },
  phoneSection: {
    title: "Personal number",
    subtitle: "+27 65 305 0930",
  },
};

export {
  settings,
  seo,
  greeting,
  degrees,
  socialMediaLinks,
  skills,
  competitiveSites,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
